import { FC, ReactNode, createContext, useContext } from 'react'

import { useQuery } from '@tanstack/react-query'
import { AnyRouter, RouteApi, getRouteApi } from '@tanstack/react-router'
import { CrbMonitorListResponse } from '~bank-crb-monitor/types'

import { templatesListQueryOptions } from '../route'

type CrbMonitorListContextValue = {
  routeApi: RouteApi<'/_app/crb-monitor/', AnyRouter>
  data: CrbMonitorListResponse
  isLoading: boolean
  refetchList: () => void
}

const CrbMonitorListContext = createContext<CrbMonitorListContextValue | undefined>(undefined)

export const useCrbMonitorListContext = () => {
  const context = useContext(CrbMonitorListContext)
  if (!context) {
    throw new Error('useCrbMonitorListContext must be used within a CrbMonitorListContext.Provider')
  }
  return context
}

export const CrbMonitorListContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const routeApi = getRouteApi('/_app/crb-monitor/')
  const search = routeApi.useSearch()
  const {
    data,
    isFetching,
    isRefetching,
    refetch: refetchList
  } = useQuery<CrbMonitorListResponse>(templatesListQueryOptions(search))
  if (!data) return null

  return (
    <CrbMonitorListContext.Provider value={{ data, routeApi, isLoading: isFetching || isRefetching, refetchList }}>
      {children}
    </CrbMonitorListContext.Provider>
  )
}
